import { IFile, statuses } from 'interfaces/file';
import { IPaginationParams, IPaginationRangeParams, IPaginationResponse } from 'interfaces/pagination';
import { Observable } from 'rxjs';

import apiService, { ApiService } from './api';

export class FileService {
  constructor(private apiService: ApiService) { }

  public list(params: IPaginationParams): Observable<IPaginationResponse<IFile>> {
    return this.apiService.get('/file', params);
  }

  public listBy(params: IPaginationRangeParams, ventureId: number, entityId: number, documentId: number): Observable<IPaginationResponse<IFile>> {
    return this.apiService.get(`/file/venture/${ventureId}/document/${documentId}/entity/${entityId}`, params);
  }

  public save(model: {
    frequency: string, criticality: string, documentId: number, file: File, expirationDate: Date
  }): Observable<any> {
    const formData = new FormData();
    formData.append('frequency', model.frequency);
    formData.append('criticality', model.criticality);
    formData.append('documentId', String(model.documentId));
    formData.append('file', model.file, model.file.name);
    formData.append('expirationDate', String(model.expirationDate));
    return this.apiService.upload('/file', formData);
  }

  public edit(model: IFile): Observable<IFile> {
    return this.apiService.put(`/file/${model.id}`, model);
  }

  public updateStatus(model: IFile): Observable<IFile> {
    return this.apiService.put(`/file/${model.id}/updateStatus`, model);
  }

  public nextStatus(id: number, status: statuses): Observable<any> {
    return this.apiService.get(`/file/${id}/nextStatusFor/${status}`);
  }

  public delete(id: number): Observable<void> {
    return this.apiService.delete(`/file/${id}`);
  }
}

const fileService = new FileService(apiService);
export default fileService;